export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/custom-script-worker.8b254b56.worker.js");
}
